import { createContext } from "react";
import type { GlossaryDescription } from "../../../../../api/spark";

/**
 * Lazily-loaded glossary descriptions, keyed by canonical term, for the step
 * currently rendering. `null` until (or unless) descriptions have loaded —
 * consumers (i.e. `GlossaryEntry`) degrade to no tooltip while absent.
 *
 * Deliberately separate from `CustomComponentsCtx`: descriptions arrive after
 * the content has rendered, so keeping them apart means only `GlossaryEntry`
 * re-renders when they land — not every block serializer.
 */
export const GlossaryDescriptionsCtx = createContext<Map<
  string,
  GlossaryDescription
> | null>(null);
